import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'badge', 'Badge', [["path",{"d":"M17 17v-13l-5 3l-5 -3v13l5 3l5 -3","key":"svg-0"}]]);